import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { finalize, take } from 'rxjs/operators';
import { Tractor } from 'src/app/shared/intefaces/tractor';
import { AnuarioService } from 'src/app/shared/services/anuario.service';
import { UploadService } from 'src/app/upload.service';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-anuario-edit',
  templateUrl: './anuario-edit.component.html',
  styleUrls: ['./anuario-edit.component.scss']
})
export class AnuarioEditComponent implements OnInit {
  tractor: any;
  anuarioForm = new FormGroup({
    brand: new FormControl('', [
      Validators.required
    ]),
    model: new FormControl('', [
      Validators.required
    ]),
    cv: new FormControl('', [
      Validators.required
    ]),
    engineModel: new FormControl(''),
    engineBrand: new FormControl(''),
    rpm: new FormControl(''),
    torque: new FormControl(''),
    reference: new FormControl(''),
    cylinders: new FormControl(''),
    volume: new FormControl(''),
    aspiration: new FormControl(''),
    injection: new FormControl(''),
    transmissionModel: new FormControl(''),
    transmissionType: new FormControl(''),
    frontRear: new FormControl(''),
    reverse: new FormControl(''),
    clutch: new FormControl(''),
    clutchTrigger: new FormControl(''),
    traction: new FormControl(''),
    differentialLock: new FormControl(''),
    tdpRpm: new FormControl(''),
    tdpTrigger: new FormControl(''),
    hydraulicFlow: new FormControl(''),
    hydraulicPressure: new FormControl(''),
    remoteControlValves: new FormControl(''),
    remoteControlFlow: new FormControl(''),
    liftCapacity: new FormControl(''),
    height: new FormControl(''),
    betweenAxles: new FormControl(''),
    freeSpace: new FormControl(''),
    turnRadius: new FormControl(''),
    weight: new FormControl(''),
    tankCapacity: new FormControl(''),
    maxSpeed: new FormControl(''),
    operationStep: new FormControl(''),
    optionals: new FormControl(''),
    slug: new FormControl(''),
  });
  image: string = '';

  constructor(
    private notifier: NotifierService,
    private uploadService: UploadService,
    private anuarioService: AnuarioService,
    private router: Router,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params.id === undefined) {
        this.notifier.notify('error', 'Trator não encontrado.');

        this.router.navigateByUrl('/anuario/tractors');
      }

      const id = params.id;

      this.anuarioService.getById(id).pipe(take(1)).subscribe(
        response => {
          this.tractor = response.data();
          this.image = this.tractor.image;

          this.anuarioForm.patchValue({
            ...this.tractor
          });

        },
        error => {
          this.notifier.notify('error', 'Trator não encontrado.');

          this.router.navigateByUrl('/anuario/tractors');
        }
      )
    })
  }

  submit(): void {
    let data = {
      ...this.anuarioForm.value,
      image: this.image,
      cv: Number(this.anuarioForm.value.cv),
      cylinders: Number(this.anuarioForm.value.cylinders),
    }

    this.anuarioService.update(this.tractor.id, data).then(() => {
      this.notifier.notify('success', 'Trator atualizado com sucesso');

      this.router.navigateByUrl('/anuario/tractors');
    }).catch((error) => {
      console.log(error);

      this.notifier.notify('error', 'Não foi possível atualizar o trator');
    });

  }

  public deleteImage(): void {
    this.notifier.notify('success', 'Imagem removida com sucesso.');

    this.image = '';
  }

  public uploadImage(file: File): void {
    const extension = file.name.split('.').pop();
    const filePath = `${uuidv4()}.${extension}`;

    this.uploadService.uploadFirebase(file, filePath).snapshotChanges().pipe(
      finalize(() => {
        this.image = filePath;

        this.notifier.notify('success', 'Imagem enviada com sucesso');
      })
    ).subscribe();


  }

}
